module.exports = __webpack_public_path__ + "static/rp-hov1-4cb1540fac00f4da7e369f890e7d0653.png";